import { DarkPalletType } from './dark'

export const crossColors: DarkPalletType = {
  cross: {
    white: '#FFFFFF',
    black: '#000000',
    100: '#F2F2F2',
    200: '#C2C2C2',
    300: '#8F8F8F',
    400: '#525252',
    500: '#262626',
    overlay: '#171717',
  },
}

export type CrossColorsType = typeof crossColors
